import ProductAjaxService from "./AjaxService";

export default class CartActions extends ProductAjaxService {
    constructor() {
        super();
        this.toggleFavorite();
    }

    toggleFavorite() {
        let self = this;
        $(document).on('click', '.add-fav:not(.open-popup)', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id'),
                category_id = $(this).attr('data-category'),
                is_await = $(this).attr('data-await');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }

            let obj = {product_id: ID, category_id: category_id};
            if(is_await === 'true') {
                obj['is_await'] = 'true';
            }

            self._POST(self.addToFavoriteURL, obj, self.updateSmallCarts);

            let $favItem = $('.add-fav[data-id='+ ID +']');
            $favItem.toggleClass('added active');

            if(is_await === 'true') {
                $favItem.toggleClass('added-fav');
            }
        });
    }

    updateSmallCarts(res) {
        if(res.success) {
            $('.xhr-count-favorite').html(res.data.count);
            if(res.data.count){
                $('.xhr-img-favorite .link-icon').attr('src' ,'/assets/images/svg/full-fav.svg');
            } else {
                $('.xhr-img-favorite .link-icon').attr('src' ,'/assets/images/svg/empty-fav.svg');
            }
            if(res.data.is_await) {
                $(document).trigger('trigger.show.popup', ['stockAvailabilityModal']);
            }
        }

    }
}
